import styled from 'styled-components';

export const CustomHorizonRadioStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  .custom-horizon-radio-item {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-block;
    background: #d9d9d9;
    border: 1px solid #000000;
    cursor: pointer;
    &.checked {
      background: #303030;
      border-color: #303030;
    }
  }
`;
